varying vec3 vColor;
uniform float uProgress;
uniform float uFlash;

void main() {
    float distanceToCenter = distance(gl_PointCoord, vec2(0.5));

    if (distanceToCenter > 0.5) discard;

    vec3 finalColor = mix(vColor, vec3(1), uFlash);
    
    float alpha = 1.0 - uProgress;
    
    gl_FragColor = vec4(finalColor, alpha);
}